import * as React from 'react';

const PrevSliderArrow = React.forwardRef((_, ref) => {
  return (
    <div
      className={'swiper-arrow arrow-left'}
      onClick={(event) => {
        event.stopPropagation();
      }}
      ref={ref}
    >
      <svg
        fill={'none'}
        height={24}
        viewBox={'0 0 24 24'}
        width={24}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={'M16.084 22H7.916C4.377 22 2 19.724 2 16.335V7.665C2 4.276 4.377 2 7.916 2H16.084C19.622 2 22 4.277 22 7.666V16.335C22 19.724 19.622 22 16.084 22Z'}
          fill={'#bcbcbc'}
          opacity={0.4}
        />
        <path
          d={'M11.145 16.2794L7.38003 12.5314C7.09703 12.2494 7.09703 11.7504 7.38003 11.4674L11.145 7.71943C11.439 7.42743 11.914 7.42843 12.206 7.72243C12.498 8.01643 12.498 8.49043 12.204 8.78343L9.72703 11.2504H16.082C16.497 11.2504 16.832 11.5864 16.832 12.0004C16.832 12.4144 16.497 12.7504 16.082 12.7504H9.72703L12.204 15.2164C12.351 15.3634 12.424 15.5554 12.424 15.7484C12.424 15.9394 12.351 16.1314 12.206 16.2774C11.914 16.5704 11.439 16.5714 11.145 16.2794Z'}
          fill={'#fefefe'}
        />
      </svg>
    </div>
  );
});

export default PrevSliderArrow;